<template>
  <RouterView />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'App',

  data() {
    return {
      printerKeepAliveIntervalId: null,
    };
  },

  computed: {
    ...mapState('bluetooth', ['isConnecting', 'isPrintJobActive']),
    ...mapGetters('bluetooth', ['isConnected']),
  },

  watch: {
    isConnected: {
      immediate: true,
      handler(isConnected) {
        if (isConnected) {
          this.startPrinterKeepAlive();
          return;
        }

        this.stopPrinterKeepAlive();
      },
    },
  },

  async created() {
    // Initialize Bluetooth module
    if (navigator.bluetooth) {
      try {
        await this.initializeBluetooth();
      } catch (error) {
        console.warn('Failed to initialize Bluetooth:', error);
      }
    }
  },

  beforeUnmount() {
    this.stopPrinterKeepAlive();
  },

  methods: {
    ...mapActions('bluetooth', ['initializeBluetooth', 'sendKeepAlive']),
    startPrinterKeepAlive() {
      if (this.printerKeepAliveIntervalId) return;

      console.log("printer keep alive");
      this.printerKeepAliveIntervalId = window.setInterval(() => {
        this.sendPrinterKeepAlive();
      }, 5000);
    },
    stopPrinterKeepAlive() {
      if (!this.printerKeepAliveIntervalId) return;

      clearInterval(this.printerKeepAliveIntervalId);
      this.printerKeepAliveIntervalId = null;
    },
    async sendPrinterKeepAlive() {
      if (!this.isConnected || this.isConnecting || this.isPrintJobActive) {
        return;
      }

      await this.sendKeepAlive();
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #434343;
  height: 100vh;
  background-color: #FAFAFA;
  overflow-y: scroll;
}
</style>
